const initialState = {};
export default function scribeNotifications(state = initialState, action) {
    switch (action.type) {
        case 'SCRIBE_CLEAR_NOTIFICATION':
            return Object.assign(Object.assign({}, state), { text: undefined, progress: undefined });
        case 'SCRIBE_SET_NOTIFICATION_TEXT':
            return Object.assign(Object.assign({}, state), { text: action.text });
        case 'SCRIBE_SET_NOTIFICATION_PROGRESS':
            return Object.assign(Object.assign({}, state), { progress: action.progress });
        default:
            // eslint-disable-next-line no-unused-expressions
            action;
            return state;
    }
}
